import { createContext } from "react";
import { IInvoiceImportedDTO } from "../../../libs/coreapi-dto/documents/importedInvoice";

export const ImportedInvoiceContext = createContext<IInvoiceImportedDTO | null>(null);
